export default __webpack_public_path__ + "static/media/Youtube.7f4cdfac.svg";